import { AdSenseConfig, AdSelectionResult } from '../types/aam.d';

/**
 * 20% 확률로 주요 광고주를 사용해야 하는지 결정합니다.
 * @returns {boolean} 주요 광고주를 사용해야 하면 true, 그렇지 않으면 false.
 */
export function shouldUsePrimaryAdvertiser(): boolean {
  return Math.random() < 0.2; // 20% 확률
}

/**
 * 주어진 너비와 높이에 따라 광고 유형을 계산합니다.
 * @param {number} width - 광고 영역의 너비.
 * @param {number} height - 광고 영역의 높이.
 * @returns {'horizontal' | 'vertical' | 'responsive'} 광고 유형.
 */
export function calculateAdSize(width: number, height: number): 'horizontal' | 'vertical' | 'responsive' {
  if (width > height) {
    return 'horizontal';
  } else if (height > width) {
    return 'vertical';
  } else {
    return 'responsive'; // 너비와 높이가 같거나 동적 크기 조정이 필요한 경우
  }
}

/**
 * Google AdSense 광고 단위를 초기화합니다.
 * (adsbygoogle = window.adsbygoogle || []).push({}); 호출.
 */
export function initializeAd(): void {
  try {
    // Check if window and window.adsbygoogle exist before pushing.
    // This function is expected to be called in a client-side environment.
    if (typeof window !== 'undefined' && (window as any).adsbygoogle) {
      ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
    } else {
      console.warn("adsbygoogle script not loaded or not in a browser environment.");
    }
  } catch (e) {
    console.error("Error initializing AdSense ad:", e);
  }
} 